export enum ToolbarSize {
  SMALL = 'small',
  REGULAR = 'regular'
}
